"use client";

import useStoreKeys from "@/hooks/useStoreKeys";
import {
	SearchSpringClient,
	getClient,
	getSearchSpringClient,
} from "@/lib/searchspring/client";
import { FC, useEffect } from "react";

interface Props {
	params: any;
	function: "search" | "suggest" | "recommend";
}

const SearchSpringUseClient: FC<Props> = (props) => {
	const { store, lang } = useStoreKeys();

	useEffect(() => {
		const doRequest = async () => {
			const client = await getClient(store, lang);
			switch (props.function) {
				case "search": {
					client.search(props.params);
					break;
				}
				case "recommend": {
					client.recommend(props.params);
					break;
				}
			}
		};

		doRequest();
	}, []);

	return null;
};

export default SearchSpringUseClient;
